import PropTypes from 'prop-types'
import styled from 'styled-components'
import { useTranslation } from 'react-i18next'

import { convertFileSize } from 'utils/strings'
import colors from 'components/utils/colors'
import IconLink from 'components/Shared/IconLink/Index'

const StyledWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  padding: 4px;
  background: ${colors.secondary95};
  user-select: none;
  cursor: default;
`

const Content = styled.div`
  display: flex;
  position: relative;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  border: 1px solid ${colors.secondary70};
  background: #FFFFFF;
  padding: 4px 11px 7px 11px;
`

const AbortButton = styled(IconLink)`
  position: absolute;
  right: 10px;
  margin-right: 2px;
`

const FileName = styled.div`
  font-size: 12px;
  line-height: 16px;
  color: ${colors.secondary20};
`

const ProgressText = styled.div`
  font-size: 10px;
  line-height: 14px;
  color: ${colors.secondary60};
  margin-bottom: 4px;
`

const ProgressLine = styled.div`
  background: ${colors.secondary95};
  width: 100%;
  height: 2px;
`

const ProgressLineBar = styled.div`
  background: ${colors.primary40};
  width: ${props => props.progressPercent}%;
  height: 100%;
  transition: 0.5s;
`

const FileProgressbar = ({ fileName, currentBytes, totalBytes, onAbort }) => {
  const { t } = useTranslation()

  if (!totalBytes || !fileName) {
    return null
  }

  const currentBytesText = convertFileSize(currentBytes)
  const totalBytesText = convertFileSize(totalBytes)
  const progressText = t('fileProgressbar.progressText', { currentBytesText, totalBytesText })
  const progressPercent = Math.min(Math.round(currentBytes / totalBytes * 100), 100)
  const showAbortButton = currentBytes < totalBytes

  return (
    <StyledWrapper>
      <Content>
        <FileName>{fileName}</FileName>
        <ProgressText>{progressText}</ProgressText>

        {showAbortButton &&
          <AbortButton iconName='icon-remove-16' onClick={onAbort} />
        }

        <ProgressLine>
          <ProgressLineBar progressPercent={progressPercent} />
        </ProgressLine>
      </Content>
    </StyledWrapper>
  )
}

FileProgressbar.propTypes = {
  fileName: PropTypes.string,
  currentBytes: PropTypes.number,
  totalBytes: PropTypes.number,
  onAbort: PropTypes.func,
}

export default FileProgressbar
